const AdvisorsBanner = () => {
  return (
    <section
      id="advisors-banner"
      className="d-flex justify-content-center align-items-center advisors-banner-background blu-background-filter"
      style={{ minHeight: '70vh', marginTop: '-4rem', paddingTop: '4rem' }}
    >
      <div className="container d-flex flex-column text-center px-3 px-lg-5">
        <h1 className="advisors-banner-title">
          Conoce a los asesores que te ayudan a transportar tu vehículo sin que manejes
        </h1>
        <p className="advisors-banner-subtitle mt-3">
          Asesores <strong>verificados</strong>, atención directa por <strong>WhatsApp</strong>.
        </p>
      </div>
    </section>
  );
};

export default AdvisorsBanner;
